import React from 'react'
import { NavigationContainer } from '@react-navigation/native'

import { RootStackNavigator } from './Stacks'
import { linking } from './Routes'
import { navigationRef } from 'app/utils/RootNavigation'
import { useKeycloak } from '@react-keycloak/web'
import { Spinner } from '@dehaat/dds'

const AppNavigator = () => {
  const { initialized } = useKeycloak()

  if (!initialized) {
    return <Spinner type="on-screen" />
  }

  return (
    <NavigationContainer ref={navigationRef} linking={linking}>
      <RootStackNavigator />
    </NavigationContainer>
  )
}

export default AppNavigator
